export default __webpack_public_path__ + "static/media/sitcom.8c21a609.png";